import { render, staticRenderFns } from "./LedgerAddressNotConfirmedModal.vue?vue&type=template&id=6b848911"
import script from "./LedgerAddressNotConfirmedModal.vue?vue&type=script&lang=js"
export * from "./LedgerAddressNotConfirmedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports